import { makeStyles } from '@material-ui/core/styles';
import TextField from 'components/CncUI/TextField';

const useStyles = makeStyles(({ palette }) => ({
  error: {
    '& p': {
      color: palette.cncUI.alert.red.primary,
    },
  },
}));

const Field = props => {
  const classes = useStyles();
  const { type, item, index, error, onChange } = props;
  const { currency, isCurrencyEnabled } = props;
  const name = type === '$' ? 'flatAmount' : 'splitPercentage';
  const failed = error || (parseInt(item[name], 10) || 0) === 0;
  const iconType =
    isCurrencyEnabled && type === '$' && currency === 'CAN' ? (
      <>
        <span style={{ fontSize: 10 }}>CA</span>$
      </>
    ) : (
      <span>{type}</span>
    );
  const icon = { endIcon: iconType };
  return (
    <TextField
      error={failed}
      name={name}
      ErrorIcon={null}
      value={parseInt(item[name], 10) || 0}
      onChange={evt => onChange(evt, index)}
      className={failed && classes.error}
      inputProps={{
        maxLength: type === '$' ? 7 : 2,
        pattern: '[0-9]*',
        inputMode: 'numeric',
      }}
      {...icon}
    />
  );
};

export default Field;
